const checkIfSticky = (stickyButtonRef: HTMLElement): boolean => {
  const offsetTop = stickyButtonRef.getBoundingClientRect().top;
  const stickyBarHeight = stickyButtonRef.offsetHeight;
  if (!offsetTop || !stickyBarHeight) return false;

  const isStickyNow = window.innerHeight <= offsetTop + stickyBarHeight;
  return isStickyNow;
};

export default checkIfSticky;
